import type { AxiosResponse } from "axios";
import { ApiInstance } from "@/api";
import type { BaseProductDto } from "@/types/product/productTypes";

export interface ProductsForConnectinSizesFilter {
  createdInOzon: boolean | null;
  createdInWb: boolean | null;
  searchPhrase: string;
  readyToExport: boolean | null;
  outOfStockFBS: boolean | null;
  outOfStockFBO: boolean | null;
  sortedField: string | null;
  isOrderByDesc: boolean | null;
  notCreatedInOzon?: boolean | null;
  notCreatedInWb?: boolean | null;
  categoryId: string | null;
}

export default class ProductsForConnectinSizes {
  static async getProductsForTable(
    take: number = 2000,
    skip: number = 0,
    filter: ProductsForConnectinSizesFilter,
  ): Promise<
    AxiosResponse<{
      [count: string]: BaseProductDto[];
    }>
  > {
    return ApiInstance.post<{
      [count: string]: BaseProductDto[];
    }>("/product/ProductsForConnectinSizes", { skip, take, ...filter });
  }
}
